//#region Imports

import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import _ from 'lodash-es';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent } from 'primeng/api';

import {
    OrderGuideServiceProxy,
    WebShopServiceProxy,
    BasketArticleDto,
    CategoryServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { appModuleAnimation, PrimengTableHelper } from '@axilla/axilla-shared';

import { AppComponentBase } from '@shared/common/app-component-base';
import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
import { AxillaPackage, BasketArticleExtendedDto } from '../../../../shared/common/shop-system/models/models';
//#endregion Imports

@Component({
    selector: 'app-confirm-order-backorder',
    templateUrl: './confirm-order-backorder.component.html',
    styleUrls: ['../../../dashboard/dashboard.component.less', './confirm-order-backorder.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class ConfirmOrderBackorderComponent extends AppComponentBase implements OnInit, OnDestroy {

    constructor(
        injector: Injector,
        private orderGuideServiceProxy: OrderGuideServiceProxy,
        private categoryServiceProxy: CategoryServiceProxy,
        private webShopServiceProxy: WebShopServiceProxy,
        private _notifyService: NotifyService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private route: ActivatedRoute,

        private _webshopService: WebshopService
    ) {
        super(injector);
    }
    get package(): AxillaPackage {
        if (!this._package) {
            this._package = this._webshopService.package;
        }

        return this._package;
    }
    set package(value: AxillaPackage) {
        this._package = value;
    }

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @Input() showPallet = false;


    private _package: AxillaPackage;


    //#region Bastet overview

    updateBasketSubscription$;

    ngOnInit(): void {
        if (!this.basket || this.basket.length === 0) {
            this._webshopService.initBasket();
        }

        this._onBasketUpdate();

        this.setDataTable();
    }

    ngOnDestroy(): void {
        this.updateBasketSubscription$.unsubscribe();
    }
    private _onBasketUpdate() {
        this.updateBasketSubscription$ = this._webshopService.basketUpdate$
            .subscribe((items: BasketArticleDto[]) => {
                this.setDataTable();
            });
    }


    getBasket(event?: LazyLoadEvent) {
        this.setDataTable();
    }

    setDataTable() {
        if (this.basket || this.basket.length >= 0) {
            this.primengTableHelper.records = this.basket;
            this.primengTableHelper.totalRecordsCount = this.basket.length;
        }
    }

    changeAmountInBasket(article: BasketArticleExtendedDto) {
        this._changeAmountInBasket(article);

    }

    private _changeAmountInBasket(article: BasketArticleExtendedDto) {
        if (+article.quantity <= 0) {
            this.notify.info('Item quantity = 0, change ');
            return;
        }

        const item = _.cloneDeep(article);
        this._webshopService.changeItem(item);
    }

    confirmChangingItemCount(article: BasketArticleExtendedDto) {
        this.changeAmountInBasket(article);
    }

    remove(item: BasketArticleExtendedDto) {
        //if (item) {
        //    this._webshopService.remove(item.id);
        //}
    }

    getBasketTotal(): number {

        let total = 0;
        _.forEach(this.basket, (item: BasketArticleExtendedDto) => {
            total += item.price * item.quantity;
        });

        return total;
    }

    //#endregion Bastet overview
}

